@if (hasPermission()) {
  <div class="row">
    <div class="toggleButtons">
      <button class="btn m-0 p-0">
        <span class="badge badge-off" (click)="app.userSettings.toggleSettings(0)" [ngbTooltip]="app.text.user.tooltipAllOff">{{app.text.user.allOff}}</span>
      </button>
      <button class="btn m-0 p-0">
        <span class="badge badge-on" (click)="app.userSettings.toggleSettings(app.userSettings.customerEmailsList.size)" [ngbTooltip]="app.text.user.tooltipAllOn">{{app.text.user.allOn}}</span>
      </button>
    </div>
  </div>
}
<div class="p-2">
  <div>
    @for (email of app.userSettings.customerEmailsList; track email) {
      <div
        class="email-option col-md-6"
        >
        <button
          [ngClass]="{ disabledButton: !hasPermission()}"
          class="btn p-1"
          (click)="app.userSettings.toggleSettings(1, email)"
          >
          @if (!app.userSettings.currentUserEmailPreferences.includes(email)) {
            <i class="fa fa-toggle-off check-off" aria-hidden="true" ></i>
          }
          @if (app.userSettings.currentUserEmailPreferences.includes(email)) {
            <i class="fa fa-toggle-on check-on" aria-hidden="true" ></i>
          }
        </button>
        <label class="fieldNameC" for="email">{{ getText(email) }}</label>
      </div>
    }
  </div>
</div>
